import { Image } from "@/components/Elements";
import { RouteConstant } from "@/routes/routeConstant";
import { RootState } from "@/store/reducers";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const MessageHeader = () => {
  const { userImageUrl, fullName } =
    useSelector((state: RootState) => state.chat.selectedRecipient) ?? {};
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(RouteConstant.Friends);
  };

  return (
    <div className="flex flex-1 p-[10px] bg-[#ffffff] shadow-lg items-center">
      <div onClick={handleGoBack} className="w-[30px] h-[20px] mr-[5px]">
        <Image src="back-grey.png" className="w-full h-full" />
      </div>
      <Image
        src={userImageUrl}
        isApiUrl
        className="w-[50px] h-[50px] rounded-[50px] border border-[#d3d3d3]"
      />
      <div className="ml-[10px]">
        <div className="text-[17px] font-extrabold">{fullName}</div>
      </div>
    </div>
  );
};
